import axios, { type AxiosError } from 'axios';
import useSWR from 'swr';
import generateCorrelationId from '../../utils';

async function hasAccessToOnlineBank(): Promise<boolean> {
  try {
    const responseIsBankCustomer = await axios.get<boolean>(
      '/bank/customers/check/is-customer',
      {
        headers: {
          'X-Correlation-ID': `document-archive-web.${generateCorrelationId()}`,
        },
      }
    );

    return responseIsBankCustomer.data;
  } catch (error) {
    console.error(
      `Failed to check access: ${error instanceof Error ? error.message : 'Unknown error'}`
    );
    return false;
  }
}

export default function useBankCustomer() {
  return useSWR<boolean, AxiosError>(
    'bankCustomerAccess',
    async () => await hasAccessToOnlineBank(),
    {
      suspense: true,
      revalidateOnFocus: false,
      revalidateIfStale: false,
    }
  );
}
